var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
'element-select',
 { 'input-height': _vm.heightis40 },
 {'long-input': _vm.longSelect},
 {'width-64': _vm.width64}
 ],style:(_vm.innerStyle)},[_c('div',[_vm._v(_vm._s(_vm.label))]),_c('el-select',{attrs:{"placeholder":_vm.$t('common.pleaseSelect')},on:{"change":_vm.selectChange},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1),(!!_vm.bottomTip)?_c('div',{staticClass:"bottom-tip"},[_vm._v(_vm._s(_vm.bottomTip))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }